module.exports = __webpack_public_path__ + "img/P1000111.702f7c55.jpg";